import { render, staticRenderFns } from "./HeaderLogoText.vue?vue&type=template&id=46367a00&scoped=true&"
import script from "./HeaderLogoText.vue?vue&type=script&lang=js&"
export * from "./HeaderLogoText.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLogoText.css?vue&type=style&index=0&id=46367a00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46367a00",
  null
  
)

export default component.exports